import { connect } from 'react-redux'
import FSUTeacher from './fsu-teacher'
import SelectSchool from './select-school/select-school.container'
import AddSchool from './add-school/add-school.container'
import { getSelectedSchool, isNewSchool } from './redux/fsu-teacher.selectors'

const mapStateToProps = state => {
  const newSchool = isNewSchool(state)
  const selectedSchool = getSelectedSchool(state)
  return {
    Screen: newSchool && !selectedSchool ? AddSchool : SelectSchool
  }
}

export default connect(
  mapStateToProps,
  null
)(FSUTeacher)
